export interface VoiceFinishMatch {
  finished: boolean;
  text: string;
}

const finishCommand = /(?:[,.!?;:—–\-\s]*(?:это\s+вс[её]|на\s+этом\s+вс[её]|у\s+меня\s+вс[её]|вс[её]\s*,?\s*(?:я\s+)?закончил(?:а)?|я\s+закончил(?:а)?|закончил(?:а)?|вс[её]\s+готово|готово|вс[её]\s*,?\s*больше\s+ничего|больше\s+ничего)[,.!?;:—–\-\s]*)$/iu;

export function extractVoiceFinishCommand(transcript: string): VoiceFinishMatch {
  const trimmed = transcript.trim();
  if (!finishCommand.test(trimmed)) return { finished: false, text: trimmed };
  return { finished: true, text: trimmed.replace(finishCommand, "").trim() };
}

export function isVoiceConfirmCommand(transcript: string): boolean {
  return /^(?:подтвердить|подтверждаю|подтверди|да\s+подтвердить)[.!?,\s]*$/iu.test(transcript.trim());
}

export function isVoiceCancelCommand(transcript: string): boolean {
  return /^(?:отмена|отмени|отменить|не\s+записывай|не\s+записывать)[.!?,\s]*$/iu.test(transcript.trim());
}
